module.exports = __webpack_public_path__ + "img/Black-dot.f396c517.png";